export const siteSettings = {
  name: "Special Expert Trading",
  link: "https://specialexperts.net",
  email: "support@specialexperts.net",
  appLink: "https://app.specialexperts.net",
};
